import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import { stepLabelClasses } from '@mui/material/StepLabel';
import { Check } from '@mui/icons-material';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.secondary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.secondary.light,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === 'dark'
        ? theme.palette.grey[800]
        : theme.palette.grey[300],
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepLabel = styled(StepLabel)(({ theme }) => ({
  // background: 'red',
  [`& .${stepLabelClasses.labelContainer} .MuiStepLabel-label`]: {
    marginTop: 0,
    fontSize: 14,
  },
  [`& .${stepLabelClasses.label}`]: {
    color:
      theme.palette.mode === 'dark'
        ? theme.palette.grey[800]
        : theme.palette.grey[400],
    [`&.${stepLabelClasses.active}`]: {
      color: theme.palette.secondary.main,
      fontWeight: 'bold',
    },
    [`&.${stepLabelClasses.completed}`]: {
      color: theme.palette.secondary.light,
      fontWeight: 'bold',
    },
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color:
    theme.palette.mode === 'dark'
      ? theme.palette.grey[700]
      : theme.palette.grey[300],
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: theme.palette.secondary.main,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: theme.palette.secondary.light,
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

const StepContainer = ({ mode }) => {
  // const strings = {
  //   term: '약관동의',
  //   signup: '정보입력',
  //   complete: '회원가입 완료',
  // };
  // const active = {
  //   term: mode === 0,
  //   signup: mode === 1,
  //   complete: mode === 2,
  // };
  // const complete = {
  //   term: mode > 0,
  //   signup: mode > 1,
  //   complete: false,
  // };

  const steps = ['약관동의', '정보입력', '회원가입 완료'];
  return (
    <Box sx={{ margin: '32px auto' }}>
      <Stepper
        alternativeLabel
        activeStep={mode}
        connector={<QontoConnector />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <QontoStepLabel StepIconComponent={QontoStepIcon}>
              {label}
            </QontoStepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepContainer;
